import Dialog from "@components/Dialog"
import localizeDate from "@helpers/localizeDate"
import { useTranslation } from "react-i18next"
import { Link } from "react-router-dom"
import { RevenueCatSubscription } from "../types"

interface Props {
  open: boolean
  onClose: () => void
  subscriptions: RevenueCatSubscription[]
}

export default function SubscriptionDialog({
  open,
  onClose,
  subscriptions,
}: Props) {
  const { t } = useTranslation()

  const expiresDate = (subscription: RevenueCatSubscription) =>
    new Date(subscription.expires_date)
  const isUnsubscribed = (subscription: RevenueCatSubscription) =>
    subscription.unsubscribe_detected_at
  const purchaseDate = (subscription: RevenueCatSubscription) =>
    new Date(subscription.purchase_date) // unix timestamp in seconds, convert to milliseconds

  const store = (subscription: RevenueCatSubscription) => {
    switch (subscription.store) {
      case null:
      case undefined:
        return t("pages.account.subscription.dialog.unknown").toUpperCase()
      case "stripe":
        return "WEB"
      default:
        return subscription.store.split("_").join(" ").toUpperCase()
    }
  }

  const showMultipleSubscriptionsWarning = subscriptions.length > 1

  return (
    <Dialog onClose={onClose} open={open}>
      <>
        <h1 className="text-center text-[25px] font-bold">
          {t("pages.account.subscription.dialog.header")}
        </h1>
        {showMultipleSubscriptionsWarning && (
          <p className="-mt-4 text-center font-bold text-red-600">
            {t("pages.account.subscription.dialog.multipleSubscriptions", {
              count: subscriptions.length,
            })}
          </p>
        )}

        {subscriptions.map((subscription) => (
          <div key={subscription.store} className="mb-9 mt-7">
            <table className="w-full table-auto">
              <tbody>
                <tr>
                  <th className="text-left">
                    {t("pages.account.subscription.dialog.type")}
                  </th>

                  <td className="py-3">{store(subscription)}</td>
                </tr>
                <tr>
                  <th className="text-left">
                    {t("pages.account.subscription.dialog.status")}
                  </th>

                  <td className="py-3">
                    {t(
                      `pages.account.subscription.dialog.${isUnsubscribed(subscription) ? "statusCanceled" : "statusActive"}`,
                    )}
                  </td>
                </tr>

                <tr>
                  <th className="text-left">
                    {t("pages.account.subscription.dialog.begins")}
                  </th>
                  <td className="py-3">
                    {localizeDate(purchaseDate(subscription))}
                  </td>
                </tr>

                <tr>
                  <th className="text-left">
                    {t("pages.account.subscription.dialog.ends")}
                  </th>

                  <td className="py-3">
                    {localizeDate(expiresDate(subscription))}
                  </td>
                </tr>
              </tbody>
            </table>
          </div>
        ))}
        <div className="text-center">
          <Link
            className="font-bold underline"
            to="/help-center"
            data-testid="button-manage"
          >
            {t("pages.account.subscription.dialog.needHelpContactUs")}
          </Link>
        </div>
      </>
    </Dialog>
  )
}
